export default __webpack_public_path__ + "static/media/security-safe-svgrepo-com.7b3bc801.svg";